import DropItem from "./DropItem";



class DropItemContainer {


    constructor() {
        this.dropItemList = []
        this.selectedStyle = null

    }

    addDropItem = (dropItem) => {
        this.dropItemList.push(dropItem);
    }


    getAsJson = () => {
        let obj = {}
        obj.dropItemList = []
        for (let i = 0; i < this.dropItemList.length; i++) {
            obj.dropItemList.push(this.dropItemList[i].getAsJson())
        }
        obj.selectedStyle=this.selectedStyle;

        return obj
    }


    initFromJson = (obj) => {

        for (let i = 0; i < obj.dropItemList.length; i++) {
            let dropItem = new DropItem()
            dropItem.initFromJson(obj.dropItemList[i])
            this.dropItemList.push(dropItem)
        }

        this.selectedStyle=obj.selectedStyle;

        this.selectedStyle[0].style.border = "solid 0px black"
        this.selectedStyle[0].style.paddingTop = "0px"

    }


    getReportAsJson=()=>{
        let obj={}
      

        return this.getAsJson()
    }


    initReportFromJson=(obj)=>{
       this.initFromJson(obj)
    }
}

export default DropItemContainer